import { useTranslation } from 'react-i18next'
import { GetInvoicesRow } from '../../types'

const TONES = {
    gray: 'bg-gray-100 text-gray-600',
    amber: 'bg-amber-50 text-amber-800',
    blue: 'bg-blue-50 text-blue-800',
    green: 'bg-green-50 text-green-800',
    red: 'bg-red-50 text-red-800',
}

/**
 * Ô "HĐ điện tử" ở danh sách hoá đơn, theo FE_INTEGRATION.md (hoá đơn điện tử) mục 8:
 * số hoá đơn `<ký hiệu>-<số>` + trạng thái (chờ mã CQT, CQT từ chối, gửi CQT lỗi, phát hành lỗi,
 * đã xác nhận sai). Giá trị lấy từ DB (cron cập nhật mã CQT 5 phút/lần), có thể chậm hơn chi tiết.
 */
const EInvoiceStatusCell = ({ row }: { row: GetInvoicesRow }) => {
    const { t } = useTranslation('invoice')
    const status = row.e_invoice_status
    const taxStatus = row.e_invoice_tax_status
    const number = [row.e_invoice_series, row.e_invoice_no]
        .filter(Boolean)
        .join('-')

    if (!status) return <span className="text-gray-400">—</span>

    let tone: keyof typeof TONES = 'gray'
    let label = ''
    let note = ''
    let strike = false

    if (status === 'publishing') {
        tone = 'amber'
        label = t('e-invoice-badge-publishing')
    } else if (status === 'failed') {
        tone = 'red'
        label = t('e-invoice-badge-failed')
    } else if (status === 'wrong') {
        tone = 'red'
        label = number
        note = t('e-invoice-badge-marked-wrong')
        strike = true
    } else if (taxStatus === 'granted') {
        tone = 'green'
        label = number
    } else if (taxStatus === 'rejected' || taxStatus === 'error') {
        tone = 'red'
        label = number
        note = t(
            taxStatus === 'rejected'
                ? 'e-invoice-list-tax-rejected'
                : 'e-invoice-badge-tax-error'
        )
    } else {
        // published, chưa có / đang chờ mã CQT
        tone = 'blue'
        label = number
        note = t('e-invoice-list-waiting-tax')
    }

    return (
        <div className="leading-tight">
            <span
                className={`inline-block rounded px-1.5 py-0.5 text-xs font-medium ${TONES[tone]} ${
                    strike ? 'line-through' : ''
                }`}
            >
                {label || '—'}
            </span>
            {note && <div className="mt-0.5 text-xs text-gray-500">{note}</div>}
        </div>
    )
}

export default EInvoiceStatusCell
